import { PageLink, PageTitle } from '_metronic/layout/core';
import { FC } from 'react';
import { useLocation } from 'react-router-dom';
import { View } from './components/View';

const CargaNominaPage: FC = () => {
  let location = useLocation();
  const breadCrumbs: Array<PageLink> = [
    {
      title: 'Nómina',
      path: location.pathname,
      isSeparator: false,
      isActive: true,
    },
    {
      title: 'Carga de nómina',
      path: '',
      isSeparator: true,
      isActive: false,
    },
  ];

  return (
    <>
      <PageTitle breadcrumbs={breadCrumbs}>Carga de Nómina</PageTitle>
      <View/>
    </>
  );
};

export {CargaNominaPage}